if (!customElements.get('vim-tool-tip')) {
  class Tooltip extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tooltipElement = null;
      this.closeBtn = null;
      this.isVisible = false;
      this.createTooltip();
      this.addEventListeners();
    }

    createTooltip() {
      this.tooltipElement = this.querySelector('.tooltip__content');
      this.closeBtn = this.tooltipElement?.querySelector('.tooltip__close');
    }

    showTooltip() {
      this.tooltipElement?.classList.add('show');
      this.isVisible = true;
      this.tooltipElement?.setAttribute('aria-live', 'polite');
      this.tooltipElement?.setAttribute('aria-hidden', 'false');
      this.closeBtn.focus(); // Set focus to the tooltip
      // Add event listener to close tooltip when clicked outside
      document.body.classList.add('hide-zonos-n-a11y');
      document.addEventListener('mousedown', this.handleOutsideClick.bind(this));
    }

    hideTooltip() {
      this.tooltipElement.classList.remove('show');
      this.isVisible = false;
      this.tooltipElement.setAttribute('aria-hidden', 'true');
      this?.focus(); // Return focus to the tooltip trigger element
      // Remove the event listener for closing tooltip
      document.body.classList.remove('hide-zonos-n-a11y');
      document.removeEventListener('mousedown', this.handleOutsideClick.bind(this));
    }

    toggleTooltip(event) {
      if (this.isVisible && !this.tooltipElement.contains(event.target)) {
        this.hideTooltip();
      } else {
        this.showTooltip();
      }
    }

    handleMouseEnter() {
      this.showTooltip();
    }

    handleOutsideClick(event) {
      if (
        !this.contains(event.target) &&
        !this.tooltipElement.contains(event.target)
      ) {
        this.hideTooltip();
      }
    }

    handleKeyDown(event) {
      if (event.key === 'Escape' && this.isVisible) {
        event.preventDefault();
        this.hideTooltip();
      }
    }

    handleTouch() {
      this.toggleTooltip();
    }

    addEventListeners() {
      this.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.toggleTooltip(evt);
      });

      document.addEventListener('keydown', this.handleKeyDown.bind(this));

      this.closeBtn?.addEventListener('click', (event) => {
        event.stopPropagation();
        this.hideTooltip();
      });
    }
  }

  customElements.define('vim-tool-tip', Tooltip)
}